<template>
    <div class="agenda">
        <ul>
            <template v-for="date in dates">
                <li v-if="nodesForDate(date).length" :key="date.toDateString()" class="date">
                    <p :class="'summary ' + dateDescription(date)">{{prettyDate(date)}}</p>

                    <node
                        v-for="(node, i) in nodesForDate(date)"
                        :key="'node-' + i"
                        :node="node"
                        :app="app"
                        :toggler="toggler"
                        :klass="dateDescription(node.date) || ' '"
                        prefix="* "
                    />
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import Node from '../node/component.vue';

function findNodesForDate(dateString, nodes, arr) {
    nodes.forEach(function(node) {
        if (node.date && (!node.value || node.value.indexOf('DONE') === -1) && node.date.toDateString() === dateString && arr.indexOf(node) === -1) {
            arr.push(node);
        }

        if (node.children && node.children.length) {
            findNodesForDate(dateString, node.children, arr);
        }
    });

    return arr;
}

function findNodesBeforeDate(date, nodes, arr) {
    nodes.forEach(function(node) {
        if (node.date && node.value && node.value.indexOf('DONE') === -1 && node.date < date) {
            arr.push(node);
        }

        if (node.children && node.children.length) {
            findNodesBeforeDate(date, node.children, arr);
        }
    });

    return arr;
}

export default {
    props: ['app', 'rootNode', 'toggler'],
    components: {
        Node
    },
    computed: {
        today() {
            var date = new Date();

            date.setHours(0, 0, 0, 0);

            return date;
        },
        overdue() {
            var _ = this;

            var a = findNodesBeforeDate(
                _.today,
                _.rootNode ? _.rootNode.children : [],
                []
            );

            return a;
        },
        dates() {
            var _ = this,
                dates = [],
                date = _.today,
                i;

            for (i = 13; i >= 0; i--) {
                dates.push(date);
                date = new Date(date);
                date.setDate(date.getDate() + 1);
            }

            return dates.sort(function(a, b) {
                if (a.getTime() < b.getTime()) return -1;
                if (a.getTime() > b.getTime()) return 1;
                return 0;
            });
        }
    },
    methods: {
        nodesForDate(date) {
            var _ = this,
                nodes = [];

            if (date.toDateString() === _.today.toDateString()) {
                nodes = _.overdue;
            }

            return findNodesForDate(
                date.toDateString(),
                _.rootNode ? _.rootNode.children : [],
                nodes,
                _.overdue
            );
        },
        prettyDate(date) {
            return date.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        dateDescription(date) {
            if (!date) {
                return;
            }

            var _ = this,
                now = new Date();

            now.setHours(0, 0, 0, 0);

            if (date < now) {
                return 'overdue';
            } else {
                if (_.prettyDate(now) === _.prettyDate(date)) {
                    return 'today';
                } else {
                    var tomorrow = new Date(now);

                    tomorrow.setDate( tomorrow.getDate() + 1 );

                    if (_.prettyDate(tomorrow) === _.prettyDate(date)) {
                        return 'tomorrow';
                    }
                }
            }
        }
    }
};
</script>
